import { UserInterface } from "../Models";

export const initialState: UserInterface = {
  user: undefined,
  token: undefined
};
